// Types and schemas (DATA-01)
export {
  moduleConfigEntrySchema,
  moduleConfigSchema,
  type ModuleConfigEntry,
  type ModuleConfig,
  type NormalizedModuleConfigEntry,
  type NormalizedModuleConfig,
} from "./types";

// Constants
export { MAX_VISIBLE_MODULES, ACTIVE_STATES } from "./constants";

// Normalization (DATA-02)
export { normalizeModuleConfig } from "./normalize";

// Routes (DATA-03)
export {
  MODULE_ROUTES,
  MAIN_KEYS,
  EXCLUDED_MODULE_KEYS,
  INSTALL_RESTRICTED_MODULE_KEYS,
  humanizeModuleKey,
  type ModuleRoutes,
} from "./routes";

// Ordering (DATA-04)
export { splitModules, type OrderedModule, type ModuleSplit } from "./ordering";

// Permissions (DATA-05)
export { canAdminModules } from "./permissions";
